<template>
  <!-- Page Content -->
  <div class="whole-page" style="height: 100%">
    <div class="navbar-div">
      <NavbarComponent :user="user" analysis="BROKER" />
    </div>
    <div class="row f-row">
      <div class="col" v-bind:class="[quoteSelectedBool ? 'col-6' : 'col-12']">
        <QuotesList
          :quotes="quotes"
          :quoteSelectedBool="quoteSelectedBool"
          @eventOnUserChangeQuote="onUserChangeQuote"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import QuotesList from "@/components/counterparties/QuotesList";

export default {
  name: "Trader",
  components: {
    NavbarComponent,
    QuotesList
  },
  data() {
    return {
      user: [],
      quotes: [
        {
          quoteId: 1,
          company: "AUTECO",
          client: "Nicolas Corredor",
          state: 1,
          notional: 1000000,
          strategy: "LONG FORWARD",
          action: "QUOTE",
          show: false,
          mu: null
        },
        {
          quoteId: 2,
          company: "NUTRESA",
          client: "Nicolas Corredor",
          state: 2,
          notional: 1000000,
          strategy: "LONG RATIO SEAGULL",
          action: "QUOTE",
          show: false,
          mu: null
        },
        {
          quoteId: 3,
          company: "FRONTERA",
          client: "Nicolas Corredor",
          state: 3,
          notional: 1000000,
          strategy: "LONG SEAGULL",
          action: "WAIT",
          show: false,
          mu: null
        },
        {
          quoteId: 4,
          company: "ITALCOL",
          client: "Nicolas Corredor",
          state: 4,
          notional: 1000000,
          strategy: "SHORT COLLAR",
          action: "CONFIRM",
          show: false,
          mu: null
        },
        {
          quoteId: 5,
          company: "ECOPETROL",
          client: "Nicolas Corredor",
          state: -1,
          notional: 1000000,
          strategy: "SHORT PARTICIPATING FORWARD",
          action: "NOTHING DONE",
          show: false,
          mu: null
        },
        {
          quoteId: 6,
          company: "DAABON",
          client: "Nicolas Corredor",
          state: 5,
          notional: 1000000,
          strategy: "SHORT SEAGULL",
          action: "CLOSED WON",
          show: false,
          mu: 5000000
        },
        {
          quoteId: 7,
          company: "ACEPALMA",
          client: "Nicolas Corredor",
          state: 5,
          notional: 1000000,
          strategy: "LONG SEAGULL",
          action: "CLOSED WON",
          show: false,
          mu: 3000000
        },
        {
          quoteId: 8,
          company: "SURA IM",
          client: "Nicolas Corredor",
          state: -1,
          notional: 1000000,
          strategy: "LONG BREAK FORWARD",
          action: "CLOSED LOST",
          show: false,
          mu: null
        }
      ]
    };
  },
  created() {
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
  },
  computed: {
    quoteSelectedBool() {
      let sel = false;
      this.quotes.forEach(function(d) {
        if (d.show === true) {
          sel = true;
        }
      });
      return sel;
    }
  },
  methods: {
    onUserChangeQuote(quote) {
      this.quotes = quote;
    }
  }
};
</script>

<style scoped></style>
